import { useMemo } from 'react';
import useProfileRole from './useProfileRole';

const _p = {
    useProfileRole
};

export const _private = _p;

/**
 * Creates a filter to hide SUPPORT role users from non-SUPPORT users
 * @param {string} namespace
 * @param {string} relation
 * @returns {object|undefined}
 */
export default function useRoleBasedFilter(namespace, relation) {
    const [currentUserRole, isReady] = _p.useProfileRole();

    return useMemo(() => {
        if (!(isReady && namespace === 'identity' && relation === 'user')) {
            return;
        }

        // current user with SUPPORT role can see all users including other SUPPORT users
        if (currentUserRole?.title === 'SUPPORT') {
            return;
        }

        // non-SUPPORT user can only see other non-SUPPORT users
        return {
            id: 'roleBasedFilter',
            hNodeType: 'ExcludedValues',
            hNodeTypeGroup: 'filter', 
            values: ['SUPPORT'],
            propertyName: 'identity:role.title',
            allowUndefined: true
        };
    }, [currentUserRole, isReady, namespace, relation]);
}
